import { jsx as _jsx } from "react/jsx-runtime";
import { Commission as PuiCommission } from "@ploy-ui/commission";
import CommissionAPI from "@ploy-lib/commission-api";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles(theme => ({
    root: {
        paddingTop: theme.spacing(8),
        padding: theme.spacing(4)
    }
}));
export const Commission = ({ dtResult, token = "", endpoint, internalUser }) => {
    const classes = useStyles();
    return (_jsx("div", { className: classes.root, children: _jsx(CommissionAPI, { token: token, endpoint: endpoint, children: api => _jsx(PuiCommission, { ...api, internalUser: internalUser }) }) }));
};
export default Commission;
//# sourceMappingURL=Commission.js.map